import React from 'react'

import { LoggedOutBoxSummaryModal } from '@features/box-summary'

import type { BoxSummaryTreatmentProps } from './props'
import { useLoggedOutBoxSummaryController } from './useLoggedOutBoxSummaryController'

const BoxSummaryTreatmentContent = (props: BoxSummaryTreatmentProps) => {
  const controller = useLoggedOutBoxSummaryController(props)

  return <LoggedOutBoxSummaryModal controller={controller} />
}

export const BoxSummaryTreatment = (props: BoxSummaryTreatmentProps) => {
  const { showDetails } = props

  // The modal renders nothing while closed, so only mount the controller-bearing
  // content when the box summary is shown. This keeps the (selector-heavy)
  // useLoggedOutBoxSummaryController hook off the menu's re-render hot path.
  if (!showDetails) {
    return null
  }

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <BoxSummaryTreatmentContent {...props} />
}
